import React, { useEffect, useState } from 'react';
import { Check, ShieldCheck, Lock, CreditCard, Timer, Users } from 'lucide-react';
import { Button } from './Button';
export function Price() {
  const [timeLeft, setTimeLeft] = useState(900); // 15 minutes in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
  const includes = ['5 módulos completos (Guía PDF)', '5 bonos exclusivos de regalo', 'Acceso inmediato a tu correo', 'Acceso de por vida y actualizaciones', 'Soporte vía WhatsApp incluido'];
  return <section id="oferta" className="py-12 md:py-16 px-3 md:px-4 bg-dark overflow-hidden" data-id="element-211">
      <div className="max-w-lg mx-auto relative" data-id="element-212">
        {/* Decorative Glow */}
        <div className="absolute -inset-4 bg-terracota/20 blur-3xl rounded-full opacity-50" data-id="element-213" />

        <div className="relative bg-gradient-to-b from-[#1a1a1a] to-black border-2 border-terracota/50 rounded-[2.5rem] p-6 md:p-10 shadow-[0_20px_50px_rgba(0,0,0,0.5)]" data-id="element-214">
          {/* Urgency Header */}
          <div className="flex flex-col items-center mb-8" data-id="element-215">
            <div className="bg-terracota text-white font-black px-5 py-1.5 rounded-full uppercase tracking-tighter text-[10px] md:text-xs mb-4 animate-pulse" data-id="element-216">
              ¡Oferta por tiempo limitado!
            </div>

            <div className="flex items-center gap-2 text-rosa font-bold text-lg md:text-xl mb-1" data-id="element-217">
              <Timer size={20} className="animate-spin-slow" data-id="element-218" />
              <span data-id="element-219">La oferta termina en: {formatTime(timeLeft)}</span>
            </div>

            <div className="flex items-center gap-2 text-gray-400 text-xs md:text-sm" data-id="element-220">
              <Users size={14} data-id="element-221" />
              <span data-id="element-222">14 personas están viendo esta oferta ahora</span>
            </div>
          </div>

          <h2 className="text-2xl md:text-3xl font-black text-white text-center mb-8 leading-tight uppercase" data-id="element-223">
            Tu transformación <br data-id="element-224" />
            <span className="text-terracota" data-id="element-225">empieza hoy</span>
          </h2>

          {/* Value List */}
          <ul className="space-y-4 mb-10" data-id="element-226">
            {includes.map((item, idx) => <li key={idx} className="flex items-start gap-3 group" data-id="element-227">
                <div className="bg-terracota/10 p-1 rounded-full shrink-0 mt-0.5 group-hover:bg-terracota/20 transition-colors" data-id="element-228">
                  <Check className="text-terracota" size={18} strokeWidth={3} data-id="element-229" />
                </div>
                <span className="text-gray-200 font-medium text-sm md:text-base leading-snug" data-id="element-230">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Pricing Box */}
          <div className="bg-white/5 rounded-3xl p-6 mb-8 border border-white/10 text-center relative overflow-hidden" data-id="element-231">
            <div className="absolute top-0 right-0 bg-rosa text-white text-[10px] font-black px-3 py-1 rounded-bl-xl uppercase" data-id="element-232">
              75% OFF
            </div>

            <p className="text-gray-500 text-xl line-through font-bold mb-1 decoration-rosa/50" data-id="element-233">
              79.990 ARS
            </p>

            <div className="flex flex-col items-center" data-id="element-234">
              <p className="text-5xl md:text-6xl font-black text-white tracking-tighter mb-1" data-id="element-235">
                19.990 <span className="text-2xl" data-id="element-236">ARS</span>
              </p>
              <p className="text-terracota font-bold text-sm uppercase tracking-widest" data-id="element-237">
                Pago único • Sin suscripciones
              </p>
            </div>
          </div>

          <div className="space-y-6" data-id="element-238">
            <Button isCheckout={true} className="w-full py-6 text-xl shadow-[0_10px_30px_rgba(217,108,138,0.3)]" data-id="element-239">
              SÍ, QUIERO EL ACCESO INMEDIATO
            </Button>

            {/* Trust Badges */}
            <div className="grid grid-cols-3 gap-2 pt-4 border-t border-white/10" data-id="element-240">
              <div className="flex flex-col items-center gap-1 text-center" data-id="element-241">
                <ShieldCheck size={20} className="text-terracota" data-id="element-242" />
                <span className="text-[10px] text-gray-400 font-medium leading-tight" data-id="element-243">
                  Compra 100% Segura
                </span>
              </div>
              <div className="flex flex-col items-center gap-1 text-center" data-id="element-244">
                <Lock size={20} className="text-terracota" data-id="element-245" />
                <span className="text-[10px] text-gray-400 font-medium leading-tight" data-id="element-246">
                  Privacidad Protegida
                </span>
              </div>
              <div className="flex flex-col items-center gap-1 text-center" data-id="element-247">
                <CreditCard size={20} className="text-terracota" data-id="element-248" />
                <span className="text-[10px] text-gray-400 font-medium leading-tight" data-id="element-249">
                  Acceso Instantáneo
                </span>
              </div>
            </div>

            {/* Mercado Pago Logo Placeholder/Text */}
            <div className="flex justify-center items-center gap-2 opacity-60 grayscale hover:grayscale-0 transition-all" data-id="element-250">
              <img src="https://logotipogratis.com/wp-content/uploads/2021/08/Mercado-Pago-Logo.png" alt="Mercado Pago" className="h-6 md:h-8 object-contain" data-id="element-251" />
            </div>
          </div>
        </div>

        {/* Urgency Footer */}
        <p className="text-center text-gray-500 text-xs mt-6 font-medium" data-id="element-252">
          Quedan solo{' '}
          <span className="text-rosa font-bold" data-id="element-253">7 cupos disponibles</span> con
          este descuento.
        </p>
      </div>
    </section>;
}